import React, { useContext } from 'react';
import { GlobalInfo } from "./context";
import { EngineerOnly } from "./Common";
import { numberWithCommas } from "./util";

export default function DiscordServersPage() {
  const context = useContext(GlobalInfo);
  
  if (!context.users) {
    return <div>Loading...</div>;
  }

  // Process users to create server statistics
  const serverStats = {};
  
  context.users.forEach(user => {
    if (user.servers && user.servers.length > 0) {
      user.servers.forEach(server => {
        if (!serverStats[server.name]) {
          serverStats[server.name] = {
            name: server.name,
            users: [],
            count: 0
          };
        }
        serverStats[server.name].users.push(user);
        serverStats[server.name].count++;
      });
    }
  });

  // Convert to array and sort by count (highest to lowest)
  const sortedServers = Object.values(serverStats).sort((a, b) => b.count - a.count);

  return (
    <EngineerOnly>
      <div className="container">
        <h3>Discord Server Statistics</h3>
        <p className="text-muted">Shows which Discord servers our users belong to, sorted by member count.</p>
        
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Discord Server</th>
              <th>User Count</th>
              <th>Users</th>
            </tr>
          </thead>
          <tbody>
            {sortedServers.map((server, index) => (
              <tr key={index}>
                <td>
                  <strong>{server.name}</strong>
                </td>
                <td>
                  <span className="badge badge-primary">
                    {numberWithCommas(server.count)}
                  </span>
                </td>
                <td>
                  <div style={{maxHeight: '200px', overflowY: 'auto'}}>
                    {server.users.map((user, userIndex) => (
                      <span key={userIndex}>
                        {user.name}
                        {userIndex < server.users.length - 1 && ', '}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {sortedServers.length === 0 && (
          <div className="alert alert-info">
            No Discord server data found for any users.
          </div>
        )}
      </div>
    </EngineerOnly>
  );
} 